import { ChipType } from '../types';
import { CHIP_300_BLUE, chipsMIN200 } from './chipsValues';
import { CHIPS_COLORS } from './colors';

export const CHIPS_MIN_300: ChipType[] = [
  {
    color: CHIPS_COLORS.BROWN,
    value: 50,
  },
  CHIP_300_BLUE,
  ...chipsMIN200,
];
